<template>
    <Card>
        <template v-slot:icon>
            <i class="fas fa-user-lock"/>
        </template>
        <template v-slot:title>
            {{ __('navigation.password_and_security') }}
        </template>
        <template v-slot:description>
            {{ __('actions.manage_thing', {thing: __('navigation.password_and_security')}) }}
        </template>

        <div>
            <div v-if="emailChangeable" class="row">
                <Modal v-if="!mfaIsEnabled" :visible="showMfaModal"
                       prevent-close
                       @update:visible="show => showMfaModal = show"
                >
                    <EnableMfa :user="user"
                               @close="showMfaModal = false"
                               @enabled="mfaIsEnabled = true"
                    />
                </Modal>

                <div class="col-xl-10">
                    <FormGroupNew v-if="!mfaIsEnabled"
                                  :label="__('user.mfa')"
                                  :description="__('user.enable_mfa_description')"
                                  required>
                        <button class="btn btn-light-success"
                                @click="showMfaModal = true"
                        >
                            <i class="fas fa-user-lock"/>
                            {{ __('actions.enable_thing', {thing: __('user.mfa')}) }}
                        </button>
                    </FormGroupNew>
                    <div v-else class="font-weight-bold font-size-lg mb-10">
                        <i class="fas fa-check-circle text-success"/>
                        {{ __('general.thing.is_enabled', {thing: __('user.mfa')}) }}
                    </div>
                </div>
            </div>

            <div v-if="emailChangeable">
                <DividerDotted class="mb-10"/>
                <div class="row">
                    <div class="col-md-6">
                        <FormGroupNew :label="__('user.email')"
                                      description="primary email address"
                                      :error="form.errors.email"
                                      required>
                            <input class="form-control" type="email" v-model="form.email">
                        </FormGroupNew>
                    </div>
                </div>
            </div>

            <form>
                <div v-if="passwordChangeable" class="row">
                    <div class="col-12">
                        <DividerDotted class="mb-10"/>
                    </div>
                    <div class="col-md-6">
                        <FormGroupNew :label="__('user.password')"
                                      :error="form.errors.password"
                                      :required="form.password.length > 0"
                        >
                            <PasswordInput v-model="form.password"/>
                        </FormGroupNew>
                    </div>
                    <div class="col-md-6">
                        <FormGroupNew :label="__('user.password_confirmation')"
                                      :error="form.errors.password_confirmation"
                                      :required="form.password.length > 0"
                        >
                            <PasswordInput v-model="form.password_confirmation"/>
                        </FormGroupNew>
                    </div>
                </div>
            </form>
        </div>

        <template v-if="emailChangeable || passwordChangeable" v-slot:footer>
            <SaveAndEnableButton :disabled="!form.isDirty" @click="submit"/>
        </template>
    </Card>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import SaveAndEnableButton from "@components/Integrations/SaveAndEnableButton.vue";
import DividerDotted from "@components/Form/DividerDotted.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import { Link } from '@inertiajs/vue2';
import PasswordInput from "@components/Form/PasswordInput.vue";
import EnableMfa from "@components/User/EnableMfa.vue";
import Modal from "@components/Modal.vue";

export default {
    components: {Modal, EnableMfa, PasswordInput, FormGroupNew, DividerDotted, SaveAndEnableButton, Card, Link},

    props: {
        user: {
            type: Object,
            required: true
        },
        mfaIsEnabled: Boolean,
        emailChangeable: Boolean,
        passwordChangeable: Boolean,
    },

    data() {
        return {
            showMfaModal: false,
            form: this.$inertia.form({
                email: this.user.email,
                password: '',
                password_confirmation: ''
            })
        }
    },

    methods: {
        submit() {
            this.form.patch(this.$route('user.security.update', [this.user.url_key]))
        }
    }
}
</script>
